// extracted by mini-css-extract-plugin
export default {"authPage":"AuthPage_authPage__kH9i0"};